import { Component } from '@angular/core';
import { AbstractLandingPageContentComponent } from '../landing-page.component';

@Component({
  selector: 'app-landing-page-admin',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class AdminLandingPageComponent extends AbstractLandingPageContentComponent {


}